(() => {
 if (window.stFuwatoroInitialized) return;
 window.stFuwatoroInitialized = true;
 const normalized = s => String(s).normalize('NFKC').toLowerCase().replace(/[\s×x・]/g,'').replace(/cm$/,'');
 function init(root=document) {
  root.querySelectorAll('[data-fw-product]').forEach(el=>{
   if(el.dataset.ready)return; el.dataset.ready='true';
   const variants=JSON.parse(el.querySelector('[data-fw-variants]').textContent);
   const native=el.querySelector('[data-fw-variant]');
   const button=el.querySelector('[data-fw-submit]');
   const main=el.querySelector('.fw-main-image');
   const fields=[...el.querySelectorAll('[data-fw-option]')];
   const update=()=>{
    const selected=fields.map(f=>f.querySelector('input:checked')?.value);
    const v=variants.find(v=>v.options.every((o,i)=>o===selected[i]));
    button.disabled=!v?.available;
    button.textContent=v?.available?button.dataset.availableLabel:(v?'売り切れ':'この組み合わせはありません');
    el.querySelector('[data-fw-price]').innerHTML=v?v.price:'—';
    native.value=v?String(v.id):'';
    el.querySelector('[data-fw-status]').textContent=selected.join(' / ');
    if(v?.image&&main){main.src=v.image;main.removeAttribute('srcset');}
    if(v){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState(null,'',url);}
   };
   fields.forEach(f=>f.addEventListener('change',update));
   el.querySelectorAll('[data-fw-image]').forEach(b=>b.addEventListener('click',()=>{
    if(!main)return;main.src=b.dataset.fwImage;main.removeAttribute('srcset');main.alt=b.dataset.fwAlt;
    el.querySelectorAll('[data-fw-image]').forEach(x=>{x.classList.toggle('active',x===b);x.setAttribute('aria-pressed',String(x===b));});
   }));
   el.querySelector('.fw-enhanced').hidden=false;
   el.querySelector('.fw-native').hidden=true;
   el.querySelector('form').addEventListener('submit',e=>{if(!native.value||button.disabled)e.preventDefault();});
  });
  root.querySelectorAll('.st-fuwatoro .marquee').forEach(el=>{
   if(el.dataset.ready)return;el.dataset.ready='true';
   const track=el.querySelector('.marquee-track');
   [...track.children].forEach(child=>{const clone=child.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.removeAttribute('data-shopify-editor-block');track.append(clone);});
   const button=el.closest('section').querySelector('.motion-toggle');
   let paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
   const toggle=()=>{el.classList.toggle('paused',paused);if(button){button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'自動スクロールは停止中 ▶':'動きを止める Ⅱ';}};
   button?.addEventListener('click',()=>{paused=!paused;toggle();});
   el.addEventListener('touchstart',()=>{paused=true;toggle();},{passive:true});toggle();
  });
 }
 document.addEventListener('click',e=>{
  const b=e.target.closest('.st-fuwatoro [data-pick],.st-fuwatoro [data-pick-size]');if(!b)return;
  const hero=document.querySelector('[data-fw-product]');if(!hero)return;
  const wanted=normalized(b.dataset.pick||b.dataset.pickSize);
  const input=[...hero.querySelectorAll('.fw-radio')].find(i=>normalized(i.value)===wanted);
  if(input){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));}
  hero.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:block:select',e=>{const el=e.target.closest('details');if(el)el.open=true;const m=e.target.closest('.marquee');if(m)m.classList.add('paused');});
})();
